'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
function getOverlaidColor(colorInput, overlayInput) {
  const color = tinycolor(colorInput).toRgb();
  const overlay = tinycolor(overlayInput).toRgb();
  const alpha = overlay.a;
  const overlaid = tinycolor({
    // `overlaid` matches the color rendered by the Figma (and Firefox), but Chrome uses a different alpha-blending algorithm resulting in a different color
    r: Math.round(overlay.r * alpha + color.r * (1 - alpha)),
    g: Math.round(overlay.g * alpha + color.g * (1 - alpha)),
    b: Math.round(overlay.b * alpha + color.b * (1 - alpha))
  });
  return overlaid.toHexString();
}
export {
  getOverlaidColor
};
